<template>
  <div class="table-container">
    <table class="table hide-medium" border="0" cellspacing="0" cellpadding="0">
      <thead class="table-header">
        <tr>
          <th class="table-header-item">{{ $t('companyLabel') }}</th>
          <th class="table-header-item">{{ $t('address') }}</th>
          <th class="table-header-item">{{ $t('SIRET') }}</th>
          <th class="table-header-item">{{ $t('activity') }}</th>
        </tr>
      </thead>
      <tbody class="table-content">
        <tr v-if="!tableValues.length" class="table-line">
          <td class="table-item center" colspan="4">{{ $t('noEtablishment') }}</td>
        </tr>
        <tr v-for="etablishment in tableValues" :key="etablishment.id" class="table-line">
          <td class="table-item">
            <div class="item black">{{ etablishment.name }}</div>
          </td>
          <td class="table-item">
            <div class="item">
              {{ etablishment.address.lines ? etablishment.address.lines.reduce((a, v) => `${a} ${v}`, '') : '' }}
            </div>
            <div class="item">{{ etablishment.address.zipCode || '' }} {{ etablishment.address.city || '' }}</div>
          </td>
          <td class="table-item">
            <div class="item">{{ $utils.sirenFormat(company.siren) }} {{ etablishment.nic || '' }}</div>
            <div class="item">
              <b>{{ $t(`etablishmentType._${etablishment.type}`) }}</b>
            </div>
          </td>
          <td class="table-item">
            <div class="item">{{ etablishment.activity }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="table-container show-medium">
      <div v-if="!tableValues.length" class="line">
        <div class="line-content">
          <div class="item">{{ $t('noEtablishment') }}</div>
        </div>
      </div>

      <div v-for="etablishment in tableValues" :key="etablishment.id" class="table-line">
        <div class="line">
          <div class="line-content name">
            <div class="item">{{ etablishment.name }}</div>
          </div>
        </div>

        <div class="line column">
          <div class="line-content">
            <div class="item">
              {{ etablishment.address.lines ? etablishment.address.lines.reduce((a, v) => `${a} ${v}`, '') : '' }}
            </div>
          </div>
          <div class="line-content">
            <div class="item">{{ etablishment.address.zipCode || '' }} {{ etablishment.address.city || '' }}</div>
          </div>
        </div>

        <div class="line column">
          <div class="line-content column">
            <div class="item">{{ $utils.sirenFormat(company.siren) }}</div>
          </div>
          <div class="line-content column">
            <div class="item">{{ etablishment.nic || '' }}</div>
          </div>
        </div>

        <div class="line">
          <div class="line-content">
            <div class="item">{{ etablishment.activity }}</div>
          </div>
        </div>
      </div>
    </div>

    <Pagination v-if="values && values.length" :pagination="pagination" :set-page="setPage" :tableValues="values" :pages="pages" :disable-dots="disableDots" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import tableMixin from '@/components/tables/TableMixin';

export default {
  components: { Pagination },
  mixins: [tableMixin],

  props: {
    company: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [this.$t('creationDate'), ''],
      values: [],
      tableMixinConfig: {
        backendPaginated: false,
        onChange: this.changePage,
        getData: this.getData,
        maxElement: 5,
      },
    };
  },

  methods: {
    async getData() {
      let data;
      if (this.values.length > 0) {
        data = this.values;
      } else {
        data = await this.$store.dispatch('getCompanyEtablishment', { searchedCompanySiren: this.company.siren });
        this.values = data;
      }
      this.pagination.totalLength = data.count;
      this.pagination.maxPage = Math.ceil(this.pagination.totalLength / this.pagination.maxElement);
      return { data, values: data.items };
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.table-container {
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-chevron,
    .number {
      cursor: pointer;
      width: 22px;
      height: 22px;
      margin: 0 10px;

      &:hover {
        color: colors.$lightblue-color;
      }

      &.disabled {
        cursor: not-allowed;
        color: rgba(colors.$lightgrey-color, 0.5) !important;

        &:after {
          border-color: rgba(colors.$lightgrey-color, 0.5) !important;
        }
      }
    }

    .number {
      color: colors.$grey-color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.current {
        background: colors.$lightblue-color;
        color: colors.$white-color;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .header {
    margin: 60px 0 0;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: flex-end;
      font-weight: 500;
      font-size: 20px;
    }

    .main-button {
      max-width: 200px;
      padding: 0;
    }
  }
}

.table .table-content .table-line {
  background: colors.$white-color;

  &.empty .table-item .item {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: colors.$lightgrey-color;
    font-size: 14px;
    font-style: italic;
  }

  &:last-child .table-item {
    border: none;
  }

  .table-item {
    border-bottom: 1px solid colors.$border-color;
    background: transparent;

    &.center {
      text-align: center;
    }

    &:last-child .item span {
      width: 100%;
      text-align: right;
    }

    .item {
      color: colors.$darkgrey-color;
      font-size: 13px;
      font-weight: normal;
      display: flex;
      justify-content: space-between;

      &.center {
        justify-content: center;
      }
    }

    &.read {
      .item {
        color: colors.$black-color;
        font-weight: 500;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .table-container {
    width: 100%;

    .table-line {
      width: 100%;
      margin: 12px 0;
      display: flex;
      flex-direction: column;

      background: colors.$unread-table-color;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 4px;

      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;

        margin: 12px 0;

        &.right {
          justify-content: flex-end;
        }

        &.column {
          flex-direction: column;
          justify-content: space-evenly;
          align-items: flex-start;
        }

        .line-content {
          display: flex;
          align-items: center;
          justify-content: space-between;

          font-weight: normal;
          font-size: 13px;
          line-height: 20px;
          color: colors.$darkgrey-color;

          .item {
            display: flex;
            align-items: center;
          }

          &.read-indication {
            align-self: flex-end;
          }

          &.name {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            color: colors.$darkgrey-color;
          }

          &.title {
            font-weight: 500;
            color: colors.$grey-color;
            line-height: 16px;
            font-size: 14px;
            margin-bottom: 8px;
          }

          &.label,
          &.date {
            font-weight: 500;
            color: colors.$black-color;
          }

          &.date,
          .internal-id {
            font-size: 12px;
          }

          &.label {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
